import {
    PencilAltIcon,
    CalendarIcon, MinusSmIcon, PlusSmIcon
} from '@heroicons/react/outline'
import { Disclosure } from '@headlessui/react'
import { BadgeCheckIcon, ChevronRightIcon } from '@heroicons/react/solid'
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'
import { cloudfront } from "../../config";
import bizStyles from '../../styles/Business.module.css'
import Layout from '../../components/Layouts/landingLayout'
import AlertTemplate from '../../components/Notification'
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import { useAuth, AuthProvider } from '../../contexts/Auth'
import Calendar from '../../components/Gthr/Scheduler/Utils/Calendar'
import { supabase } from '../../utils/supabaseClient'
import Meta from "../../components/Meta"
import * as ga from '../../lib/gtag'
import { useRouter } from 'next/router'
import BurnoutQuiz from '../../components/Quiz/BurnoutQuiz'

const faqs = [
    {
      question: "How many times a week will I meet with my coach?",
      answer:
        "Plans start with meetings once a week over video chat.  Additional meetings are available with an upgraded plan",
    },
    {
        question: "How are coaches qualified?",
        answer:
          "All coaches have prior experience as life coaches and are licensed medical professional or certified coaches through the International Coaching Federation or the Life coach School",
      },
      {
        question: "How does burnout coaching work?",
        answer:
          `Clients meet with coaches to identify the sources of burnout then commit to actionable solutions through practicing mindfulness, learning greater self-awareness, and improving conflict resolution.  This may  
          include learning how different personalities are more susceptible to burnout or how subtle life changes can help alleviate burnout `,
      },
      {
        question: "What if I need to reschedule?",
        answer:
          "Clients can check-in with their coaches then reschedule based on their coach's schedule through their client dashboard",
      },
      {
        question: "How much does Plaza burnout coaching cost?",
        answer:
          "We charge between $600 - $900 per month depending on the package selected.  Ask your employer if you qualify for reimbursement for burnout coaching",
      },
      {
        question: "What if I have additional questions?",
        answer:
          "Use the chat in the bottom-right corner to ask additional questions",
      },
  ]
export default function Service() {
    let tz = Intl.DateTimeFormat().resolvedOptions().timeZone ? Intl.DateTimeFormat().resolvedOptions().timeZone : "America/Los_Angeles"
    const [subPage, setSubPage] = useState(0)
    const [submitted, setSubmitted] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [ checkUser, setCheckUser] = useState(true)
    const [meeting, setMeeting] = useState({"name": "", "person":"", "email": "", "notes": "", "dateStr": null, "rand": (Math.random() + 1).toString(36).substring(7), "client_profile_id": null,
    "appointment_datetime": null, "client_user_id":null, "timezone":tz, "meeting_dates": [] })
    const [form, setForm] = useState({
        name: "",
        email: "",
        account_type:"marketplace",
        password:"",
        confirm_password:"",
    })
    const router = useRouter()
    const { user, signOut } = useAuth()

    const handleFormChange = (e) => {
        let newForm = { ...form }
        if (e.target) {
            newForm[e.target.name] = e.target.value
            setForm(newForm)
        }
    }


    const checkErrors = () => {
        if (form.password !== form.confirm_password) {
            let newError = {...error}
            newError= "Passwords do not match"
            setError(newError)
            return false
        }
        if (form.password.length < 8) {
          let newError = {...error}
          newError = "Password too short"
          setError(newError)
            return false
        } 
        if (!form.name || !form.email) {
          let newError = {...error}
          newError = "Please enter a username and email"
          setError(newError)
          return false
        }

        return true
    }
    

    const submitRegister = async (e) => {
        e.preventDefault()
        setLoading(true)

        const bool = checkErrors()
        if (!bool) {
            setLoading(false)
            return
        }

        const { user, error } = await supabase.auth.signUp({
            email: form.email,
            password: form.password,
          })


        if (!error) {
            ga.event({
              action:'user_register',
            })

            const rand = (Math.random() + 1).toString(36).substring(7)
            const profile = await supabase
                .from("main_profile")
                .insert({user_id:user.id, name:form.name, account_type:form.account_type, email: form.email, unique_slug: rand, timezone: tz })
            
     
            //send email 
            await fetch("/api/contact/register", {
              method: "POST",
              headers: {'Content-Type': 'application/json'},
              body:JSON.stringify({
                email: form.email,
                marketplace:true
              })
            })
         
            //push to stripe subscription ?? 
            router.push(`/network/onboarding`)
            // route.push(`/stripe/subscribe?step=plans`)
           
            
        } else {
            setEmailError(error.message)
        }
    }
   




    return (
        <div className="relative overflow-hidden">
            <Meta
                title="Plaza Burnout Quiz"
                description="Plaza burnout coaching quiz "

            />

            <main>
         

   




                <div className="py-16 bg-slate-200/50 overflow-hidden lg:pt-24 lg:pb-36">
                    <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
                        <svg
                            className="hidden lg:block absolute  transform -translate-x-1/2 -translate-y-1/4"
                            width={404}
                            height={584}
                            fill="none"
                            viewBox="0 0 404 784"
                            aria-hidden="true"
                        >
                            <defs>
                                <pattern
                                    id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
                                    x={0}
                                    y={0}
                                    width={20}
                                    height={20}
                                    patternUnits="userSpaceOnUse"
                                >
                                    <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width={404} height={584} fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)" />
                        </svg>
                        <svg
                            className="hidden lg:block absolute  transform right-0 -translate-y-1/6"
                            width={404}
                            height={584}
                            fill="none"
                            viewBox="0 0 404 784"
                            aria-hidden="true"
                        >
                            <defs>
                                <pattern
                                    id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
                                    x={0}
                                    y={0}
                                    width={20}
                                    height={20}
                                    patternUnits="userSpaceOnUse"
                                >
                                    <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width={404} height={584} fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)" />
                        </svg>

                        <div className="blur-3xl  ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-400" />

                        <div className="relative" id="bookDemo">
                            <BurnoutQuiz 
                            
                            />
                        </div>
                        <div className="blur-3xl right-0 mr-48 absolute -mt-20 h-32 w-48 -z-10 bg-fuchsia-400" />

        
                    </div>




                </div>

     

                <section className="pt-10 bg-slate-200/50 -mt-0 sm:pt-10 lg:pt-0 lg:pb-14 lg:overflow-hidden mb-2 sm:mb-40 md:mb-40 lg:mb-0">
                    <div className="mx-auto max-w-7xl lg:px-8">
                        <div className="lg:grid lg:grid-cols-2 lg:gap-8">
                            <div className="mx-auto h-full max-w-md px-4 sm:max-w-2xl sm:px-6 sm:text-center lg:px-0 lg:text-left lg:flex lg:items-center">
                                <div className="lg:py-12">
                
                                    <h1 className="mt-4 text-5xl tracking-tight font-extrabold mb-10 text-black sm:mt-5 sm:text-6xl lg:mt-2 xl:text-5xl">
                                        <span className="block ">Beat <span className="text-fuchsia-600">burnout</span> and build up your</span>
                                        <span className="block "><span className="underline decoration-fuchsia-600 decoration-wavy decoration-4">mental fitness </span></span>
                                    </h1>
                                    <div className="blur-3xl  -ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-500" />

                                    <p className="mt-3 text-base text-gray-700 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                                        Plaza&apos;s coaching platform matches professionals with certified coaches to help alleviate burnout symptoms and manage stress in the workplace 

                                    </p>

                                </div>
                            </div>
                            <div className=" lg:pt-20 -mb-16 sm:-mb-48 lg:m-0 lg:relative">

                                <div className="blur-3xl mt-20 -ml-10 right-0 absolute h-32 w-32 -z-10 bg-fuchsia-500" />
                                <div className='my-auto mx-auto'>
          
                                <div className='flex flex-row justify-center space-y-1 mx-auto sm:mx-0'>
                                        <div className="blur-3xl  -ml-10 flex flex-row   absolute h-32 w-32 -z-10 bg-fuchsia-500"/>
                                        <div className='w-60 h-60 mr-3 -mb-5 overflow-hidden'>
                                        <video autoPlay loop muted className='rounded-xl w-30 h-32 object-cover object-top shadow-lg'>
                                        <source src={`${cloudfront}/media/stock_videos/video-chat-woman-talk.mp4`} type="video/mp4" />
                                        </video>
                
                                        </div>
                                        <div className='w-60 h-60 mb-3 mr-3 sm:pt-32'>
                                        <video autoPlay loop muted className='rounded-xl w-30 h-32 object-cover shadow-lg' >
                                        <source src={`${cloudfront}/media/stock_videos/video-chat-manager.mp4`} type="video/mp4" />
                                        </video>

                                        </div>
                                </div>
                                </div>

                            </div>
                        </div>
                        <div className=''>

<br /> <br /> <br /> <br /> <br /> <br />
<p className="text-center">
    <Link href="/terms-conditions" prefetch={false}>
        <a > Terms & Conditions | </a>
    </Link>
    <Link href="/cookie-policy" prefetch={false}>
        <a> Cookie Policy | </a>
    </Link>
    <Link href="/privacy-policy" prefetch={false} ><a>Privacy Policy</a></Link>
</p>
{/* <p className="text-center">
<Link href="/contact" passhref>
<Button variant="outline-purple" size="sm" className={footerStyles.no_sell_link}>Do Not Sell My Info</Button>
</Link>
</p> */}
<p className="text-center text-gray-400">© 2023 Ordinary Media, LLC. All Rights Reserved.</p>
</div>
                    </div>
                </section>


            </main>

            <style jsx global>{`
         .img-cont > span {
          overflow:visible !important;
         }

         body {
            overlfow
         }

        `}</style>
        </div>



    )
}


const alertOptions = {
    // you can also just use 'bottom right'
    position: positions.BOTTOM_RIGHT,
    timeout: 3000,
    offset: '10px',
    containerStyle: { 'zIndex': '9999' },
    // you can also just use 'fade'
    transition: transitions.FADE,
}

Service.getLayout = function getLayout(page) {
    return (
        <AlertProvider template={AlertTemplate} {...alertOptions}>
            <AuthProvider>
                <Layout>
                    {page}
                </Layout>
            </AuthProvider>
        </AlertProvider>
    )
}


